// DO NOT set the `name` and `ticker` properties manually
// Instead use one of the get token metadata scripts https://github.com/ExodusMovement/exodus-core/tree/master/packages/assets-base#get-token-metadata

export default [
  {
    name: 'gmx_avalanchec_c7b658d1',
    displayName: 'GMX',
    decimals: 18,
    ticker: 'GMXavalanchecC7B658D1',
    displayTicker: 'GMX',
    addresses: { current: '0x62edc0692BD897D2295872a9FFCac5425011c661' },
    info: {
      description:
        'GMX is the utility and governance token for the GMX exchange, an easy-to-use spot and perpetual exchange with low fees and reduced liquidation risk.',
      twitter: 'https://twitter.com/GMX_IO',
      website: 'https://gmx.io/',
      telegram: 'https://t.me/GMX_IO',
    },
    primaryColor: '#60CFC8',
    gradientColors: ['#60CFC8', '#4312E8'],
    gradientCoords: { x1: '11.118%', y1: '26.577%', x2: '24.212%', y2: '18.305%' },
  },
  {
    name: 'joe_avalanchec_872bcd49',
    displayName: 'JOE',
    displayTicker: 'JOE',
    ticker: 'JOEavalanchec872BCD49',
    decimals: 18,
    addresses: { current: '0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd' },
    info: {
      description:
        'JOE is the native utility token of Trader JOE, a decentralized exchange (DEX) with DeFi features such as trading, yield farming, staking, and lending and borrowing.',
      website: 'https://traderjoexyz.com/avalanche',
      twitter: 'https://twitter.com/traderjoe_xyz',
      telegram: 'https://t.me/traderjoe_xyz',
    },
    primaryColor: '#DB5B54',
    gradientColors: ['#A24741', '#F2716A'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'png_avalanchec_4c320d14',
    displayName: 'Pangolin',
    decimals: 18,
    ticker: 'PNGavalanchec4C320D14',
    displayTicker: 'PNG',
    addresses: { current: '0x60781C2586D68229fde47564546784ab3fACA982' },
    info: {
      description:
        'Pangolin is the governance token for Pangolin Exchange, a multichain and community-powered decentralized exchange (DEX) on the Avalanche network.',
      reddit: 'https://reddit.com/r/PangolinExchange',
      twitter: 'https://twitter.com/pangolindex',
      website: 'https://pangolin.exchange/',
    },
    primaryColor: '#FFC800',
    gradientColors: ['#E1AA00', '#FFC800'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'qi_avalanchec_19fd2065',
    displayName: 'BENQI',
    decimals: 18,
    ticker: 'QIavalanchec19FD2065',
    displayTicker: 'QI',
    addresses: { current: '0x8729438EB15e2C8B576fCc6AeCdA6A148776C0F5' },
    info: {
      description:
        'BENQI is a non-custodial liquidity market that offers DeFi features including lending, borrowing, and rewards. Its low fees and fast transactions offer relief for users faced with congestion on the Ethereum network.',
      twitter: 'https://twitter.com/BenqiFinance',
      website: 'https://app.benqi.fi/',
    },
    primaryColor: '#00B2ED',
    gradientColors: ['#107698', '#00B2ED'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'savax_avalanchec_4c4408bd',
    displayName: 'BENQI Liquid Staked AVAX',
    decimals: 18,
    ticker: 'SAVAXavalanchec4C4408BD',
    displayTicker: 'SAVAX',
    addresses: { current: '0x2b2C81e08f1Af8835a78Bb2A90AE924ACE0eA4bE' },
    info: {
      description:
        'Users receive the SAVAX token when they stake AVAX on BENQI. BENQI is a non-custodial liquidity market that offers DeFi features including lending, borrowing, and rewards. Its low fees and fast transactions offer relief for users faced with congestion on the Ethereum network.',
      twitter: 'https://twitter.com/BenqiFinance',
      website: 'https://app.benqi.fi/',
    },
    primaryColor: '#00B2ED',
    gradientColors: ['#107698', '#00B2ED'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'usdte_avalanchec_7d310603',
    displayName: 'Bridged USDT',
    decimals: 6,
    ticker: 'USDTEavalanchec7D310603',
    displayTicker: 'USDT.e',
    addresses: { current: '0xc7198437980c041c805A1EDcbA50c1Ce5db95118' },
    info: {
      description:
        'USDT.e on Avalanche® is a token representing USDT on Avalanche that was bridged from the Ethereum blockchain via the Avalanche Bridge.',
      twitter: 'https://twitter.com/tether_to',
      website: 'https://tether.to/',
      telegram: 'https://t.me/OfficialTether',
    },
    primaryColor: '#53AE94',
    gradientColors: ['#53AE94', '#2E9175'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'usdc_avalanchec_185c8bd7',
    displayName: 'USDC',
    decimals: 6,
    ticker: 'USDCavalanchec185C8BD7',
    displayTicker: 'USDC',
    addresses: { current: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E' },
    primaryColor: '#3E90E8',
    gradientColors: ['#3E90E8', '#2775CA'],
    gradientCoords: { x1: '102%', y1: '101%', x2: '0%', y2: '0%' },
  },
  {
    name: 'usdt_avalanchec_d80c1afa',
    displayName: 'Tether USD',
    decimals: 6,
    ticker: 'USDTavalanchecD80C1AFA',
    displayTicker: 'USDT',
    addresses: { current: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7' },
    info: {
      description:
        'Tether is a multi-chain stablecoin. Each USDT token is designed to be backed by a U.S. Dollar held in banking reserves.',
      twitter: 'https://twitter.com/tether_to',
      website: 'https://tether.to/',
      telegram: 'https://t.me/OfficialTether',
    },
    primaryColor: '#2EC9C9',
    gradientColors: ['#009393', '#2EC9C9'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
]
